export default {
  baseUrl: "https://omanghub-live-api.cubettech.in",
  anabotApiBase: "https://anabotv2.cubettech.in",
  portalUrl: "https://omanghub-live-api.cubettech.in",
  productionUrl: "https://omanghub.cubettech.in",
  s3Url: "https://omanghub-prod.s3.af-south-1.amazonaws.com"
};
export const qbAdminId = "132060393";

const siteConfig = {
  siteName: "Omang",
  siteIcon: "ion-flash",
  footerText: `Omang ©${new Date().getFullYear()}`,
};
const themeConfig = {
  topbar: "themedefault",
  sidebar: "themedefault",
  layout: "themedefault",
  theme: "themedefault",
};
const language = "english";
export { siteConfig, language, themeConfig };
